/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  CalculationWithOverviewResponseCollectionResponse,
  Condition,
  EntityListSkuResponseCollectionResponse,
  ErrorResponse,
  ForecastMonthlyOverviewResponseCollectionResponse,
  NonSaleDailyOverviewResponseCollectionResponse,
  SaleDailyOverviewResponseCollectionResponse,
  SaleMonthlyOverviewResponseCollectionResponse,
  SkuAttributeResponseCollectionResponse,
  SkuAvailableSupplyResponseCollectionResponse,
  SkuResponseCollectionResponse,
  SkuResponseDataResponse,
  Sorting,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class Skus<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Skus
   * @name SkusList
   * @request GET:/Skus
   * @response `200` `SkuResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  skusList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SkuResponseCollectionResponse, ErrorResponse>({
      path: `/Skus`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetSku
   * @request GET:/Skus/{id}
   * @response `200` `SkuResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSku = (id: number, params: RequestParams = {}) =>
    this.http.request<SkuResponseDataResponse, ErrorResponse>({
      path: `/Skus/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetSkuAttributes
   * @request GET:/Skus/{id}/Attributes
   * @response `200` `SkuAttributeResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkuAttributes = (id: number, params: RequestParams = {}) =>
    this.http.request<SkuAttributeResponseCollectionResponse, ErrorResponse>({
      path: `/Skus/${id}/Attributes`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetAvailableSupplies
   * @request GET:/Skus/{id}/AvailableSupplies
   * @response `200` `SkuAvailableSupplyResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getAvailableSupplies = (id: number, params: RequestParams = {}) =>
    this.http.request<SkuAvailableSupplyResponseCollectionResponse, ErrorResponse>({
      path: `/Skus/${id}/AvailableSupplies`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetSkuEntityLists
   * @request GET:/Skus/{id}/EntityLists
   * @response `200` `EntityListSkuResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkuEntityLists = (id: number, params: RequestParams = {}) =>
    this.http.request<EntityListSkuResponseCollectionResponse, ErrorResponse>({
      path: `/Skus/${id}/EntityLists`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetSkuCalculationsBySource
   * @request GET:/Skus/{id}/BySourceCalculations
   * @response `200` `CalculationWithOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkuCalculationsBySource = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationWithOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Skus/${id}/BySourceCalculations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetSkuCalculationsByTarget
   * @request GET:/Skus/{id}/ByTargetCalculations
   * @response `200` `CalculationWithOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkuCalculationsByTarget = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationWithOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Skus/${id}/ByTargetCalculations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetSkuMonthlySaleWithinMonthsRange
   * @request GET:/Skus/{id}/MonthlySales/MonthsRange/{monthsRange}
   * @response `200` `SaleMonthlyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkuMonthlySaleWithinMonthsRange = (
    id: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<SaleMonthlyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Skus/${id}/MonthlySales/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetSkuDailySale
   * @request GET:/Skus/{id}/DailySales/MonthsRange/{monthsRange}
   * @response `200` `SaleDailyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkuDailySale = (id: number, monthsRange: number, params: RequestParams = {}) =>
    this.http.request<SaleDailyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Skus/${id}/DailySales/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetSkuDailyInboundsWithinMonthsRange
   * @request GET:/Skus/{id}/DailyInbounds/MonthsRange/{monthsRange}
   * @response `200` `NonSaleDailyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkuDailyInboundsWithinMonthsRange = (
    id: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<NonSaleDailyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Skus/${id}/DailyInbounds/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetSkuDailyOutboundsWithinMonthsRange
   * @request GET:/Skus/{id}/DailyOutbounds/MonthsRange/{monthsRange}
   * @response `200` `NonSaleDailyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkuDailyOutboundsWithinMonthsRange = (
    id: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<NonSaleDailyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Skus/${id}/DailyOutbounds/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Skus
   * @name GetSkuMonthlyForecast
   * @request GET:/Skus/{id}/MonthlyForecasts
   * @response `200` `ForecastMonthlyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkuMonthlyForecast = (id: number, params: RequestParams = {}) =>
    this.http.request<ForecastMonthlyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Skus/${id}/MonthlyForecasts`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
